export const passengerType: any = {
  adult: "大人",
  child: "子供",
  infant: "幼児(0 ~ 1歳)",
};
